export const AUTO_POPULATED_PLACES = (eventId?: string | null) => `autoPopulatedAccommodationPlaces_${eventId}`;
export const FEEDBACK_STORAGE_KEY = (eventId?: string | null) => `travel_map_feedback_submitted_${eventId}`;
export const IS_PREVIEW_BLURRED_KEY = (eventId?: string | null) => `is_preview_blurred_${eventId}`;
